import { Room } from 'models/index';
import { Model as RoomModel } from 'models/room/interface';

import { endpoint, EndpointError } from '../endpoint';

export type GetRoomsByIdsParams = {
  ids: string[];
  withFullUsersData?: boolean;
};
export type GetRoomsByIdsResult = { rooms: Array<RoomModel> | Array<Room.RoomDataAdminResponse> };
export type GetRoomsByIdsError = EndpointError;

export const getRoomsByIds = endpoint<GetRoomsByIdsParams, GetRoomsByIdsResult, GetRoomsByIdsError>({
  method: 'POST',
  url: () => `/room/get-rooms-by-ids`,
});
